var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "../../views/modal/info_modal.component";
import { ModalService } from "../../views/modal/base_modal.component";
import { TranslateService } from "../../translate/translate.service";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { HelperService } from "../../lib/helper.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ChartParams } from "../../views/chart/chart.component";
var SiteTopDetailsModalComponent = /** @class */ (function (_super) {
    __extends(SiteTopDetailsModalComponent, _super);
    function SiteTopDetailsModalComponent(activeModal, helper, translate, modalService, filter) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.helper = helper;
        _this.translate = translate;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.chart = new ChartParams();
        return _this;
    }
    SiteTopDetailsModalComponent.prototype.ok = function () {
        this.close();
    };
    return SiteTopDetailsModalComponent;
}(InfoModalComponent));
export { SiteTopDetailsModalComponent };
